<template>
    <h3
        class="legacy-title"
        :class="border ? 'legacy-title-border' : ''"
    >
        <slot></slot>
    </h3>
</template>

<script>
    export default {
        name: "Title",

        props: {
            'border': {
                type: Boolean,
                default: false,
            }
        }
    }
</script>

<style
    lang="scss"
    scoped
>
    .legacy-title {
        color: var(--color-accent) !important;
        font-size: 1.3rem;
    }

    .legacy-title-border {
        &:after {
            content: "";
            display: inline-block;

            border-top: 1px solid var(--color-accent);
            width: 100%;
        }
    }
</style>
